import { useCollection } from '@cloudscape-design/collection-hooks';
import Loading from '@risksmart-app/components/src/loading';
import Table from '@risksmart-app/components/src/table';
import type { FC } from 'react';
import { LoadFailureContent } from 'src/components/LoadFailureContent';
import { useTppResponses } from 'src/hooks/useTppResponses';
import { PageLayout } from 'src/layouts';

import { useColumnDefinitions } from './table.config';

const Page: FC = () => {
  const { data, loading, error } = useTppResponses();
  const columnDefinitions = useColumnDefinitions();
  const { items, collectionProps } = useCollection(
    data?.third_party_response ?? [],
    {
      propertyFiltering: {
        filteringProperties: [],
        empty: <div>{'You have no questionnaires'}</div>,
      },
      sorting: {
        defaultState: {
          sortingColumn: columnDefinitions[1],
        },
      },
    }
  );

  if (loading) {
    return (
      <PageLayout>
        <Loading />
      </PageLayout>
    );
  }

  // Without this the empty table renders "You have no questionnaires" on a
  // failed read — a respondent can't tell a fetch failure from having none.
  if (error) {
    return (
      <PageLayout>
        <LoadFailureContent />
      </PageLayout>
    );
  }

  return (
    <PageLayout
      actions={<></>}
      title={'Questionnaires'}
      meta={{
        title: 'Questionnaires',
      }}
    >
      <Table
        columnDefinitions={columnDefinitions}
        {...collectionProps}
        items={items}
        loading={false}
      />
    </PageLayout>
  );
};

export default Page;
